'use client';
import { forwardRef } from 'react';
import { Box } from '@wanteddev/wds-engine';
import Typography from '../typography/index.mjs';
import { pushBadgeStyle } from './style.mjs';
import { jsx } from 'react/jsx-runtime';

var PushBadge = forwardRef(({ variant = "dot", children, ...props }, ref) => {
  const renderChild = {
    ["dot"]: /* @__PURE__ */ jsx(
      Box,
      {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 4 4",
        fill: "none",
        sx: (theme) => ({
          width: "4px",
          height: "4px",
          color: theme.palette.primary.normal
        }),
        children: /* @__PURE__ */ jsx("circle", { cx: "2", cy: "2", r: "2", fill: "currentColor" })
      }
    ),
    ["number"]: children,
    ["new"]: "N"
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "span",
      ref,
      ...props,
      sx: [pushBadgeStyle({ variant }), props.sx],
      children: variant === "dot" ? renderChild[variant] : /* @__PURE__ */ jsx(Typography, { variant: "caption2", weight: "bold", align: "center", children: renderChild[variant] })
    }
  );
});
PushBadge.displayName = "PushBadge";
var push_badge_default = PushBadge;

export { push_badge_default as default };
